// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".copy-plugin[data-v-4697bcd0]{display:flex;align-items:center;justify-content:flex-end;padding:0 4%;height:5vh;background-color:#fbefd9}.copy-plugin a[data-v-4697bcd0]{color:#cc8b63;margin-left:.2rem;font-weight:700;font-size:13px}", ""]);
// Exports
module.exports = exports;
